import React, { useContext } from 'react'
import { Button, ButtonGroup, MenuItem, Select } from '@mui/material';
import { CouponsContext} from '../../context/CouponsContext';
import CountCoupons from './CountCoupons';
import CategoryFilter from './CategoryFilter';
import { useSearchParams } from 'react-router-dom';
import { FiltersMobile, FlexContainerCustom } from './Styled';
import {useMediaQuery} from '@mui/material';
import { useTheme } from '@emotion/react';
import { StyledFormControl } from '../../styles/common/UIComponents';
const Filters = ({slug, noCount}) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery('(min-width:1025px) and (max-width:1114px)'); 

  const [searchParams, setSearchParams] = useSearchParams();

  const updateType = (type) => {
    type ? searchParams.set("type", type) : searchParams.delete("type");
    searchParams.delete("page");
    setSearchParams(searchParams);
  };

  

  return (
    <div>
      {isMobile? (
        <FiltersMobile>
            <StyledFormControl>
                <Select
                  value={searchParams.get("type") || ""}
                  onChange={(e) => updateType(e.target.value)}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value="">
                      <em>Todos</em>
                  </MenuItem>
                  <MenuItem value="ONLINE">
                      <em>Cupons</em>
                  </MenuItem>
                  <MenuItem value="OFFER">
                      <em>Ofertas</em>
                  </MenuItem>
                </Select>
            </StyledFormControl>
            <CategoryFilter slug={slug} />
          </FiltersMobile>

      ): (
        <FlexContainerCustom
        maxWidth={909.5}
        width="100%"
        justify= {isTablet ? "space-around" : "space-between"} 
        align="center"
        margin="0 auto"
        hideOnMobile
        >
            
            {noCount? null : (
              <CountCoupons
                slug= {slug}>
              </CountCoupons>
            )}
            {/* <ButtonGroup variant="outlined" aria-label="Basic button group"
              sx={{
                color: 'var(--c-brand-primary)'
              }}
            >
                <Button variant={searchParams.get("type") === null ? "contained" : "outlined"} onClick={() => updateType("")}>Todos</Button>
                <Button  variant={searchParams.get("type") === "ONLINE" ? "contained" : "outlined"} onClick={() => updateType("ONLINE")}>Cupons</Button>
                <Button variant={searchParams.get("type") === "OFFER" ? "contained" : "outlined"} onClick={() => updateType("OFFER")}>Ofertas</Button>
            </ButtonGroup> */}
            <StyledFormControl 
            sx={{margin: "0px"}}
            >
                <Select
                  value={searchParams.get("type") || ""}
                  onChange={(e) => updateType(e.target.value)}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value="">
                      <em>Todos</em>
                  </MenuItem>
                  <MenuItem value="ONLINE">
                      <em>Cupons</em>
                  </MenuItem>
                  <MenuItem value="OFFER">
                      <em>Ofertas</em>
                  </MenuItem>
                </Select>
            </StyledFormControl>
            <div>

            <CategoryFilter slug={slug}/>
            </div>
        </FlexContainerCustom>
      )}

    </div>
  )
}

export default Filters